import { render, staticRenderFns } from "./categoryGroupList.vue?vue&type=template&id=5fa74ec2&scoped=true"
import script from "./categoryGroupList.vue?vue&type=script&lang=js"
export * from "./categoryGroupList.vue?vue&type=script&lang=js"
import style0 from "./categoryGroupList.vue?vue&type=style&index=0&id=5fa74ec2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa74ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fa74ec2')) {
      api.createRecord('5fa74ec2', component.options)
    } else {
      api.reload('5fa74ec2', component.options)
    }
    module.hot.accept("./categoryGroupList.vue?vue&type=template&id=5fa74ec2&scoped=true", function () {
      api.rerender('5fa74ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/system/categoryGroupList.vue"
export default component.exports